module.exports = __webpack_public_path__ + "img/img_exhibition_ch.230d4f67.png";